import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  &lt;a href='/info/ei\_leidnud\_sobivat\_toodet'&gt;Kliki siia&lt;/a&gt; ja me aitame sind sobiva toote leidmisel.

  <span style="color:#85c1dc;">**FI:**</span>
  &lt;a href='/info/ei\_leidnud\_sobivat\_toodet'&gt;Kliki siia&lt;/a&gt; ja me aitame sind sobiva toote leidmisel.

  <span style="color:#85c1dc;">**RU:**</span>
  &lt;a href='/info/ei\_leidnud\_sobivat\_toodet'&gt;Kliki siia&lt;/a&gt; ja me aitame sind sobiva toote leidmisel.
*/
/* @__NO_SIDE_EFFECTS__ */
const m289 = msg(
  mf`<a href='/info/ei_leidnud_sobivat_toodet'>Kliki siia</a> ja me aitame sind sobiva toote leidmisel.`,
  mf`<a href='/info/ei_leidnud_sobivat_toodet'>Kliki siia</a> ja me aitame sind sobiva toote leidmisel.`,
  mf`<a href='/info/ei_leidnud_sobivat_toodet'>Kliki siia</a> ja me aitame sind sobiva toote leidmisel.`,
)

export { m289 as 'w.module.no-results.hall.bottom-text' }